export class Message {
    // tslint:disable-next-line: variable-name
    public static Record_NOT_FOUND = 'Record not found';
    public static SUCCESS = 'success';
    public static ERROR = 'error';
    public static UPCOMING='upcoming';
    public static REJECTED='rejected'
}